// General
import "./app-routing.scss";
import { Outlet, useLocation } from "react-router-dom";
// Static Data
import routeConst from "../../const/routeConst";
import utilityConst from "../../const/utilityConst";
// Redux
import { useSelector } from "react-redux";
// Material UI
import { useMediaQuery } from "@mui/material";

const AppRouting = () => {
  // Redux variables
  const sugarbookTheme = useSelector((state) => state.app.sugarbookTheme);

  // MUI variables
  const isMobile = useMediaQuery("(max-width: 720px)");

  // Router variables
  const location = useLocation();

  // Utility Functions
  const returnBackground = () => {
    if (isMobile) {
      if (
        location.pathname === routeConst.landing.path ||
        location.pathname === routeConst.login.path ||
        location.pathname === routeConst.join.path ||
        location.pathname === routeConst.forgotPassword.path ||
        location.pathname === routeConst.accountSignup.path ||
        location.pathname === routeConst.introductionSignup.path ||
        location.pathname === routeConst.usernameSignup.path ||
        location.pathname === routeConst.usernameSignupComplete.path ||
        location.pathname === routeConst.detailsSignup.path ||
        location.pathname === routeConst.premiumBenefits.path ||
        location.pathname === routeConst.verify.emailVerification.path ||
        location.pathname === routeConst.verify.emailVerification.altPath ||
        location.pathname === routeConst.phoneAuthentication.path ||
        location.pathname === routeConst.phoneAuthentication.altPath ||
        location.pathname === routeConst.verify.mobileVerification.path ||
        location.pathname === routeConst.verify.mobileVerification.altPath ||
        location.pathname === routeConst.verify.customerSupportInfo.mobile.path
      ) {
        return "mobile-registration-background";
      }

      switch (sugarbookTheme) {
        case utilityConst.sugarbookTheme.christmas:
          if (
            location.pathname === routeConst.landing.path ||
            location.pathname.includes(routeConst.login.path)
          ) {
            return "mobile-christmas-background";
          } else if (
            location.pathname.includes(routeConst.accountSignup.path) ||
            location.pathname.includes(routeConst.phoneAuthentication.path) ||
            location.pathname.includes(
              routeConst.phoneAuthentication.altPath
            ) ||
            location.pathname.includes(routeConst.infoSignup.path) ||
            location.pathname.includes(routeConst.missingDetails.path) ||
            location.pathname.includes(routeConst.torSignup.path) ||
            location.pathname.includes(routeConst.descriptionSignup.path) ||
            location.pathname.includes(routeConst.lifestyleSignup.path) ||
            location.pathname.includes(routeConst.detailSignup.path) ||
            location.pathname.includes(routeConst.live.path) ||
            location.pathname.includes(routeConst.profile.overview.path) ||
            location.pathname.includes(
              routeConst.verify.sugarbookVerified.path
            ) ||
            location.pathname.includes(
              routeConst.verify.sugarbookVerified.status.path
            )
          ) {
            return "mobile-white-background-color";
          }

          return "mobile-default-background-color";
        case utilityConst.sugarbookTheme.valentine:
          if (
            location.pathname === routeConst.landing.path ||
            location.pathname.includes(routeConst.login.path)
          ) {
            return "mobile-default-background-color";
          } else if (
            location.pathname.includes(routeConst.accountSignup.path) ||
            location.pathname.includes(routeConst.phoneAuthentication.path) ||
            location.pathname.includes(
              routeConst.phoneAuthentication.altPath
            ) ||
            location.pathname.includes(routeConst.infoSignup.path) ||
            location.pathname.includes(routeConst.missingDetails.path) ||
            location.pathname.includes(routeConst.torSignup.path) ||
            location.pathname.includes(routeConst.descriptionSignup.path) ||
            location.pathname.includes(routeConst.lifestyleSignup.path) ||
            location.pathname.includes(routeConst.detailSignup.path) ||
            location.pathname.includes(routeConst.live.path) ||
            location.pathname.includes(routeConst.profile.overview.path) ||
            location.pathname.includes(
              routeConst.verify.sugarbookVerified.path
            ) ||
            location.pathname.includes(
              routeConst.verify.sugarbookVerified.status.path
            )
          ) {
            return "mobile-white-background-color";
          }

          return "mobile-default-background-color";
        default:
          return "mobile-white-background-color";
      }
    } else {
      if (
        location.pathname === routeConst.landing.path ||
        location.pathname === routeConst.login.path ||
        location.pathname === routeConst.join.path ||
        location.pathname === routeConst.introductionSignup.path ||
        location.pathname === routeConst.accountSignup.path ||
        location.pathname === routeConst.usernameSignup.path ||
        location.pathname === routeConst.usernameSignupComplete.path ||
        location.pathname === routeConst.detailsSignup.path ||
        location.pathname === routeConst.premiumBenefits.path ||
        location.pathname === routeConst.verify.emailVerification.path ||
        location.pathname === routeConst.verify.emailVerification.altPath ||
        location.pathname === routeConst.phoneAuthentication.path ||
        location.pathname === routeConst.phoneAuthentication.altPath ||
        location.pathname === routeConst.verify.mobileVerification.path ||
        location.pathname === routeConst.verify.mobileVerification.altPath ||
        location.pathname ===
          routeConst.verify.customerSupportInfo.mobile.path ||
        location.pathname === routeConst.forgotPassword.path
      ) {
        return "desktop-registration-background";
      }

      if (
        location.pathname.includes(routeConst.accountSignup.path) ||
        location.pathname.includes(routeConst.verify.emailVerification.path) ||
        location.pathname.includes(
          routeConst.verify.emailVerification.altPath
        ) ||
        location.pathname.includes(routeConst.phoneAuthentication.path) ||
        location.pathname.includes(routeConst.phoneAuthentication.altPath) ||
        location.pathname.includes(routeConst.verify.mobileVerification.path) ||
        location.pathname.includes(
          routeConst.verify.mobileVerification.altPath
        ) ||
        location.pathname.includes(routeConst.infoSignup.path) ||
        location.pathname.includes(routeConst.torSignup.path) ||
        location.pathname.includes(routeConst.descriptionSignup.path) ||
        location.pathname.includes(routeConst.detailSignup.path) ||
        location.pathname.includes(routeConst.lifestyleSignup.path)
      ) {
        return "";
      }

      switch (sugarbookTheme) {
        case utilityConst.sugarbookTheme.christmas:
          return "christmas-background";
        case utilityConst.sugarbookTheme.anniversary:
          // return "desktop-background-color"; // Apply temporarily for anniversary
          return "anniversary-background";
          return;
        case utilityConst.sugarbookTheme.valentine:
          return "valentine-background";
        case utilityConst.sugarbookTheme.raya:
          return "raya-background";
        case utilityConst.sugarbookTheme.cny:
          return "cny-background";
        default:
          return "desktop-background-color";
      }
    }
  };

  return (
    <div id="body-container" className={returnBackground()}>
      <Outlet />
    </div>
  );
};

export default AppRouting;
